import { useState } from 'react';
import { faqItems, footerLinks } from '@/mocks/blackliao';

export default function FaqBoard() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-8 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-3 md:gap-4">
          {/* left intro */}
          <div className="lg:col-span-2 rounded-lg border border-background-200 bg-primary-500 text-background-50 p-5 md:p-7 flex flex-col overflow-hidden relative">
            <span className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-background-50/10"></span>
            <div className="relative">
              <span className="inline-flex items-center gap-1 rounded-full bg-background-50/15 px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap">
                <i className="ri-secure-payment-line"></i>新黑料网站规 · 信任
              </span>
              <h2 className="mt-3 text-xl md:text-2xl font-black leading-snug">理性吃瓜，我们一起把社区守好</h2>
              <p className="mt-2 text-sm leading-relaxed text-background-50/90">
                这里是新黑料网论坛、热帖、讨论、评论、社区与围观汇聚的第一现场。好氛围需要每个人维护，先读清规则再发言，围观也安心。
              </p>
              <div className="mt-5 space-y-2.5">
                {[
                  { icon: 'ri-check-double-line', text: '不实投稿将标注“存疑”并下架' },
                  { icon: 'ri-shield-check-line', text: '被误伤者可优先申诉与澄清' },
                  { icon: 'ri-eye-close-line', text: '保护当事人隐私与个人边界' },
                ].map((t) => (
                  <div key={t.text} className="flex items-center gap-2.5 rounded-md bg-background-50/10 px-3 py-2.5">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-50 text-primary-600 text-sm"><i className={t.icon}></i></span>
                    <span className="text-sm text-background-50">{t.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* right FAQ accordion */}
          <div className="lg:col-span-3 rounded-lg border border-background-200 bg-background-50 p-4 md:p-6">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm md:text-base font-bold text-foreground-900 flex items-center gap-1.5">
                <i className="ri-questionnaire-line text-accent-600"></i>围观前必读 · 常见问题
              </h3>
              <span className="text-[11px] text-foreground-500 whitespace-nowrap">FAQ</span>
            </div>
            <div className="space-y-2">
              {faqItems.map((f, i) => (
                <div key={f.q} className="rounded-md border border-background-200 bg-background-100/60 overflow-hidden">
                  <button
                    onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                    className="flex w-full items-center justify-between gap-3 px-3.5 py-3 text-left cursor-pointer"
                  >
                    <span className="text-[13px] md:text-sm font-semibold text-foreground-900 flex items-center gap-2">
                      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-secondary-100 text-secondary-700 text-[11px] font-bold">{i + 1}</span>
                      {f.q}
                    </span>
                    <i className={`${openIdx === i ? 'ri-subtract-line text-primary-600' : 'ri-add-line text-foreground-500'} text-lg shrink-0`}></i>
                  </button>
                  <div className={`grid transition-all duration-300 ${openIdx === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                    <div className="overflow-hidden">
                      <p className="px-3.5 pb-3.5 pl-10 text-[13px] leading-relaxed text-foreground-700">{f.a}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}